
export default function Testimonials() {
  const testimonials = [
    {
      name: "Maria Silva",
      location: "São Paulo, SP",
      rating: 5,
      text: "Incrível! Em apenas 3 semanas meu Golden Retriever aprendeu todos os comandos básicos. O método é muito claro e fácil de seguir. Recomendo demais!",
      image: "https://public.readdy.ai/ai/img_res/62491e562882fd42748d1fa8f04e01fc.jpg"
    },
    {
      name: "Carlos Mendes",
      location: "Rio de Janeiro, RJ",
      rating: 5,
      text: "Meu Beagle era muito agitado e não obedecia nada. Depois de aplicar as técnicas do ebook, ele se tornou muito mais calmo e obediente. Valeu cada centavo!",
      image: "https://readdy.ai/api/search-image?query=Confident%20Brazilian%20man%20in%20his%2040s%20with%20friendly%20smile%20professional%20headshot%20natural%20daylight%20approachable%20expression%20smart%20casual%20attire%20neutral%20background%20authentic%20warm%20look%20contemporary%20portrait&width=200&height=200&seq=testimonial-carlos-mendes-002&orientation=squarish"
    },
    {
      name: "Ana Costa",
      location: "Belo Horizonte, MG",
      rating: 5,
      text: "Estava desesperada com os latidos do meu Poodle. O ebook me ensinou técnicas que realmente funcionam. Agora temos paz em casa e meu cachorro está muito mais feliz!",
      image: "https://readdy.ai/api/search-image?query=Cheerful%20Brazilian%20woman%20in%20her%2040s%20with%20bright%20smile%20professional%20portrait%20soft%20natural%20light%20kind%20expression%20elegant%20casual%20clothing%20clean%20background%20genuine%20happiness%20modern%20headshot&width=200&height=200&seq=testimonial-ana-costa-003&orientation=squarish"
    }
  ];

  return (
    <section className="py-24 bg-gradient-to-br from-white to-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <div className="inline-block bg-[#FFB800] text-[#0A2463] px-6 py-2 rounded-full text-sm font-bold mb-6">
            ⭐ AVALIAÇÕES REAIS
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-[#0A2463] mb-4">
            O Que Nossos Clientes Dizem
          </h2>
          <p className="text-xl text-gray-600 mb-6">
            Mais de 15.000 tutores já transformaram seus cães
          </p>
          <div className="flex justify-center gap-1 mt-4">
            {[1, 2, 3, 4, 5].map((star) => (
              <i key={star} className="ri-star-fill text-[#FFB800] text-3xl"></i>
            ))}
            <span className="ml-3 text-2xl text-gray-700 font-bold">4.9/5.0</span>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <div 
              key={index}
              className="bg-gradient-to-br from-gray-50 to-white border-2 border-gray-200 rounded-2xl p-6 hover:shadow-xl transition-all duration-300 hover:border-[#FFB800]"
            >
              <div className="flex items-center gap-4 mb-4">
                <div className="w-16 h-16 rounded-full overflow-hidden flex-shrink-0">
                  <img 
                    src={testimonial.image} 
                    alt={testimonial.name}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div>
                  <h4 className="font-bold text-[#0A2463] text-lg">{testimonial.name}</h4>
                  <p className="text-sm text-gray-600">{testimonial.location}</p>
                </div>
              </div>

              <div className="flex gap-1 mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-[#FFB800] text-lg"></i>
                ))}
              </div>

              <p className="text-gray-700 leading-relaxed">
                "{testimonial.text}"
              </p>

              <div className="mt-4 pt-4 border-t border-gray-200">
                <div className="flex items-center gap-2 text-green-600">
                  <i className="ri-checkbox-circle-fill"></i>
                  <span className="text-sm font-semibold">Compra Verificada</span>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-16 text-center">
          <div className="inline-flex items-center gap-3 bg-gradient-to-r from-[#0A2463] to-[#1E3A8A] text-white px-8 py-4 rounded-2xl">
            <i className="ri-shield-check-line text-[#FFB800] text-3xl"></i>
            <div className="text-left">
              <p className="font-bold text-lg">Satisfação Garantida</p>
              <p className="text-sm text-gray-300">07 dias para testar sem riscos</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
